import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "col-12 q-py-lg q-px-md table-mobile-even-bg",
  style: {"border-top":"1px solid var(--border-color)","background":"#FBFBFB"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 flex items-center" }
const _hoisted_4 = { class: "additional-text q-mr-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" }, null, -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "additional-text q-mr-sm" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "additional-text q-mr-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    rows: _ctx.rows,
    columns: _ctx.columns,
    "row-key": "id",
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
    loading: _ctx.loading,
    onRequest: _ctx.onRequest,
    "binary-state-sort": "",
    flat: "",
    grid: _ctx.$q.screen.width <= 1199
  }, _createSlots({ _: 2 }, [
    (_ctx.$q.screen.width <= 1199)
      ? {
          name: "item",
          fn: _withCtx((props) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('offer_id')) + ":", 1),
                  _createTextVNode(" " + _toDisplayString(props.row.id), 1)
                ])
              ]),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('offerName')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(props.row.name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('balance_hold')) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.getAffBalancesRaw(props.row.balances)), 1)
                ])
              ])
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["rows", "columns", "pagination", "loading", "onRequest", "grid"]))
}